/** @format */

export const COMPONENT_TITLE_SX = {
  fontSize: {
    xs: '14px',
    sm: '16px',
    md: '18px',
  },
  fontWeight: 600,
  margin: 0,
  mb: {
    xs: 1,
    sm: 2,
  },
  px: {
    xs: 1,
    sm: 0,
  },
  lineHeight: 1.25,
};

export const COMPONENT_SUBTITLE_SX = {
  fontSize: {
    xs: '12px',
    sm: '13px',
    md: '14px',
  },
  fontWeight: 500,
};
